module.exports = __webpack_public_path__ + "img/75.03a170e7.png";